import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { ref } from 'vue';

// 响应式数据

export default {
  __name: 'GoTop',
  setup(__props) {
    const flag = ref(false);

    // 回到顶部方法
    const GoTop = () => {
      (function smoothscroll() {
        const currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
        if (currentScroll > 0) {
          window.requestAnimationFrame(smoothscroll);
          window.scrollTo(0, currentScroll - currentScroll / 10);
        }
      })();
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        id: "GoTop",
        onClick: _cache[0] || (_cache[0] = $event => GoTop())
      }, [...(_cache[1] || (_cache[1] = [_createElementVNode("span", {
        class: "icon-chevron-up"
      }, null, -1)]))]);
    };
  }
};